import { render, staticRenderFns } from "./SecondaryPalette.vue?vue&type=template&id=7f5e7a48&scoped=true"
import script from "./SecondaryPalette.vue?vue&type=script&lang=js"
export * from "./SecondaryPalette.vue?vue&type=script&lang=js"
import style0 from "./SecondaryPalette.vue?vue&type=style&index=0&id=7f5e7a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5e7a48",
  null
  
)

export default component.exports